/**
 * 星形状：同一关里 1★..M★ 的相对价（bps，10000 = 1.00）。
 *
 * 系统内置一条，不再逐关配（leo 2026-10-09）：线上所有代理逐关配的都是同一条
 * [1.00, 1.20, 1.44, 2.50, 3.12]，管端也一直没有填它的入口，逐关那一列只剩拦发布的作用。
 * 4★ 处跳 +72% 是竞品口径的付费墙。cfg_main_city.star_shape_bps 这一列保留但不再读。
 *
 * 星级数不是 5 时按这条线等距插值：1★ 永远 1.00、M★ 永远 3.12，中间按位置线性取值。
 *
 * 纯模块、不依赖任何运行时：服务端算价（city-costs.ts）和管端预览（web/src/lib/model.ts）共用这一份。
 */
export const BUILTIN_STAR_SHAPE_BPS: readonly number[] = [10000, 12000, 14400, 25000, 31200];

export function builtinStarShape(nLevels: number): number[] {
  if (!Number.isInteger(nLevels) || nLevels < 1) throw new RangeError(`星级数 ${nLevels} 不是正整数`);
  const base = BUILTIN_STAR_SHAPE_BPS;
  const last = base.length - 1;
  if (nLevels === 1) return [base[0]];
  return Array.from({ length: nLevels }, (_, i) => {
    const x = (i * last) / (nLevels - 1);
    const j = Math.min(Math.floor(x), last - 1);
    return Math.round(base[j] + (base[j + 1] - base[j]) * (x - j));
  });
}
